import { Typography } from '@mui/material'
import AccordionSetup from '../AccordionSetup'
import AddCircleOutlineOutlined from '@mui/icons-material/AddCircleOutlineOutlined'
import MarkUnreadChatAltOutlinedIcon from '@mui/icons-material/MarkUnreadChatAltOutlined'
import { useContext, useState } from 'react'
import CreatePost from './CreatePost'
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework'
import { enqueueSnackbar } from 'notistack'
import PostBubble from './PostBubble'
import { EventPostDto } from '../../../interfaces/IEvent'

interface PostProps {
  eventId: string
  eventPosts: EventPostDto[]
  onUpdateEventView: (eventId: string) => void
}

function PostContainer({ eventId, eventPosts, onUpdateEventView }: PostProps) {
  const [open, setOpenDialog] = useState(false)
  const { context } = useContext(EbAuthenticatedAppContext)

  const handleOpenCreateEventPost = () => {
    setOpenDialog(true)
  }

  const handleClose = () => {
    setOpenDialog(false)
  }

  const handleCreate = () => {
    setOpenDialog(false)
    onUpdateEventView(eventId)
  }

  const handleDeletePost = async (postId: string) => {
    const response = await context.restApiClient.buildRequest(`/api/event/${eventId}/post/${postId}/delete-post`).deleteAsync()

    if (response.error) {
      enqueueSnackbar(<Typography variant="body2">Kunne ikke slette meldingen. Prøv igjen eller kontakt systemansvarlig.</Typography>, {
        variant: 'error',
      })
    } else {
      enqueueSnackbar(<Typography variant="body2">Meldingen er slettet.</Typography>, { variant: 'success' })
      return onUpdateEventView(eventId)
    }
  }

  return (
    <>
      <AccordionSetup
        title="Diskusjon"
        icon={<MarkUnreadChatAltOutlinedIcon />}
        actionIcon={<AddCircleOutlineOutlined />}
        action={handleOpenCreateEventPost}
        scrollToBottom={true}
        contentHeight={750}
      >
        {eventPosts && eventPosts.length > 0 ? (
          eventPosts.map((eventPost: EventPostDto, index) => {
            return <PostBubble key={index} eventPost={eventPost} onDelete={handleDeletePost} />
          })
        ) : (
          <Typography variant="body2">Ingen innlegg.</Typography>
        )}
      </AccordionSetup>

      <CreatePost eventId={eventId} open={open} onClose={handleClose} onCreate={handleCreate} />
    </>
  )
}

export default PostContainer
